import { checkinApi } from '@/services/api/httpClient';
import { getInitialState } from './state';

const actions = {
  async searchMdmProfessional({ commit }, data) {
    commit('enableLoader', true);

    const url = `/medical-order/identify-professional?council=${data.council}&registryNumber=${data.value}&councilState=${data.uf}`;

    try {
      const professional = await checkinApi().get(url);
      const mdmDataProfessional = professional?.data || getInitialState().data;

      commit('SET_PROFESSIONALIDENTIFICATION', mdmDataProfessional);
      return mdmDataProfessional;
    } catch (error) {
      console.error(error);
    } finally {
      commit('enableLoader', false);
    }
  },
  async searchOcrMedicalIdentification({ rootState }, data) {
    const { id, unitId } = rootState.currentAdmission.data;
    const url = `/ocr/professionals?admissionId=${id}&unitId=${unitId}`;
    checkinApi().post(url, data);
  },
  async pullingMedicalIdentification({ rootState }) {
    const { id } = rootState.currentAdmission.data;
    return await callMedicalIdentification(id, 0);
  },
  isElegibleProfessionalStep({ commit }, data) {
    commit('SET_IS_ELEGIBLE_PROFESSIONAL_STEP', data);
  },
};

async function callMedicalIdentification(admissionId, tryNumber) {
  const vueAppMaxTryNumberPullingMedicalIdentification =
    process.env.vueAppMaxTryNumberPullingMedicalIdentification || 3;
  const vueAppSecondsDelayPullingMedicalIdentification =
    process.env.vueAppSecondsDelayPullingMedicalIdentification || 1;
  if (tryNumber >= vueAppMaxTryNumberPullingMedicalIdentification) {
    return null;
  }

  let ret = null;

  await new Promise((resolve) =>
    setTimeout(resolve, vueAppSecondsDelayPullingMedicalIdentification * 1000),
  );

  const url = `/ocr/queue?admissionId=${admissionId}`;
  const content = await checkinApi().get(url);

  if (content?.data?.data?.status === 'OCR_SUCCESS') {
    ret = content.data.data;
  } else {
    ret = await callMedicalIdentification(admissionId, ++tryNumber);
  }

  return ret;
}

export default actions;
